/*
 * Ryan O'Dowd
 * 2025-04-18
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
// @NOTE: via chatgpt
import React, {
  useEffect,
  useRef,
} from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const GoogleAppointmentButton = () => {
  const styles = hooks.useStyles(getStyles);

  const scriptLoadedRef = useRef(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Load CSS
    const link = document.createElement('link');
    link.href = 'https://calendar.google.com/calendar/scheduling-button-script.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    // Load Script
    if (!scriptLoadedRef.current) {
      const script = document.createElement('script');
      script.src = 'https://calendar.google.com/calendar/scheduling-button-script.js';
      script.async = true;
      script.onload = () => {
        if (window.calendar && containerRef.current) {
          window.calendar.schedulingButton.load({
            url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2wBysO9KrlkdWPMkqK3wbItq-3aCxypscXNSgytK-zYPdWbd-ItAIiXLIAtyTdLMh7ym9W36Ys?gv=true',
            color: '#c6ff00',
            label: 'Schedule a demo', // @TODO: i18n
            target: containerRef.current,
          });
        }
      };
      document.body.appendChild(script);
      scriptLoadedRef.current = true;
    } else if (window.calendar && containerRef.current) {
      window.calendar.schedulingButton.load({
        url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2wBysO9KrlkdWPMkqK3wbItq-3aCxypscXNSgytK-zYPdWbd-ItAIiXLIAtyTdLMh7ym9W36Ys?gv=true',
        color: '#c6ff00',
        label: 'Schedule a demo', // @TODO: i18n
        target: containerRef.current,
      });
    }
  }, []);

  return (
    <View style={styles.container}>
      <View ref={containerRef} style={styles.container} />
    </View>
  );
};

export default GoogleAppointmentButton;
